<template>
    <el-row>
      <el-col :span="24">
        <el-select size="mini" v-model="selectfunc" :placeholder="$t('OM.select', { msg: 'OM.select' })" style="margin-right: 10px;width: 100px; float: left">
          <el-option
            v-for="item in allselectfunc"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="search" size="mini" :placeholder="$t('OM.search', { msg: 'OM.search' })" style=" width: 500px;margin-bottom:10px; float: left"/>
        <el-col :span="4">
        <el-button style="margin-left: 20px" size="mini" type="primary" @click="getOprDataList()">{{ $t('kbinfo.select', { msg: 'kbinfo.select' }) }}</el-button>
        <el-button size="mini" type="danger" @click="reset()">{{ $t('charger.reset', { msg: 'charger.reset' }) }}</el-button>
        </el-col>
      </el-col>
    </el-row>
    
    <el-table tooltip-effect="dark"
            border
            stripe
            highlight-current-row
            v-loading="loading"
            :data="oprList"
            ref="table"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            >
      <el-table-column :label="$t('OM.table.user', { msg: 'OM.table.user' })" prop="name"></el-table-column>
      <el-table-column :label="$t('OM.table.ip', { msg: 'OM.table.ip' })" prop="ipaddr"></el-table-column>
      <el-table-column :label="$t('OM.table.broswer', { msg: 'OM.table.broswer' })" prop="browser"></el-table-column>
      <el-table-column :label="$t('OM.table.os', { msg: 'OM.table.os' })" prop="systemopr"></el-table-column>
      <el-table-column :label="$t('OM.table.oprTime', { msg: 'OM.table.oprTime' })" prop="opertime" sortable></el-table-column>
      <el-table-column :label="$t('OM.table.oprDetail', { msg: 'OM.table.oprDetail' })" prop="content"></el-table-column>
    </el-table>
  
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5,10,20,100,1000]"
      :page-size="pageSize"
      :total="totalRow"
      layout="sizes, total, prev, pager, next, jumper"
    ></el-pagination>
  </template>
  <script>
  import axios from 'axios';
  import { baseUrl_New } from '../../axios/urlconfig';
  import { format } from 'date-fns';
import { getRequest } from '../../axios/axios';
  
  export default{
      data(){
          return{
              oprList: [],
              totalRow: 0, //总数据量
              currentOprList: [], // 当前显示的数据页
              currentPage: 1, // 当前页码
              pageSize: 10, // 每页显示的数据条数
              allselectfunc: [{
              label: this.$t('OM.table.user', { msg: 'OM.table.user' }),
              value: 'name'
              },{
              label: this.$t('OM.table.ip', { msg: 'OM.table.ip' }),
              value: 'ipaddr'
              },{
              label: this.$t('OM.table.oprDetail', { msg: 'OM.table.oprDetail' }),
              value: 'content'
              }],
              search: "",
              selectfunc: "name",
          }
      },
      created(){
          this.getOprDataList();
      },
      methods:{
          handleCurrentChange(currentPage) {
          this.currentPage = currentPage;
          this.getOprDataList();
      },
  
       // 处理分页组件的每页显示条数改变事件
       handleSizeChange(pageSize) {
        this.pageSize = pageSize;
        this.getOprDataList();
      },
  
       // 更新当前显示的数据页
       updateCurrentOprList() {
          if (!Array.isArray(this.oprList)) {
          this.oprList = []; // 如果不是数组，则初始化为空数组
          }
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.currentOprList = this.oprList.slice(startIndex, endIndex);
        },
        reset(){
          this.search = '';
          this.getOprDataList();
        },
       getOprDataList(){
          const pageNum = this.currentPage;
          const pageSize = this.pageSize;
          const fieldName = this.selectfunc;
          const fieldValue = this.search;
          let params = { pageNum, pageSize };
          if(fieldValue !== null && fieldValue !== undefined && fieldValue !== ''){
            params = { pageNum, pageSize, fieldName, fieldValue };
          }
          getRequest(baseUrl_New + '/oprlog/list',  params ).then(response => {
          console.log(response);
          this.oprList = response.list; // 确保数据在 response.data.list 中
          this.totalRow = response.total; // 确保总数据量在 response.data.total 中
          this.oprList = response.list.map(item => ({
        ...item,
        opertime: this.formatDate(item.opertime),
        }));
          this.updateCurrentOprList(); // 加载数据后更新当前显示的数据页
      });
      },
      formatDate(dateString) {
        // 将日期字符串转换为日期对象
        const date = new Date(dateString);
        // 使用date-fns库格式化日期
        return format(date, 'yyyy-MM-dd HH:mm:ss');
      },
  }
  }
  
  </script>
  
  <style scoped>
  .el-table {
    margin-top: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #fff;
  }
  
  .el-table th,
  .el-table td {
    padding: 12px 16px;
    text-align: center;
  }
  
  .el-table th {
    background-color: #f5f5f5;
  }
  
  .el-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .el-table-column--selection {
    width: 50px;
  }
  
  </style>